import { jsx } from 'react/jsx-runtime';

const postPageRouterCls = "_61p10mijmp";
function PostPageRouterPlaceholder() {
  return /*#__PURE__*/jsx("div", {
    className: postPageRouterCls
  });
}

export { PostPageRouterPlaceholder, postPageRouterCls };
import "./post-page-router.linaria.module.css";
//# sourceMappingURL=post-page-router.js.map
